import { Component, Inject, LOCALE_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from './login/login.service';
import { PrimeNGConfig, Translation } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { HttpApiService } from 'src/commons/services/http/http-api.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  subscription!: Subscription;

  constructor(private router: Router,private route: ActivatedRoute,private loginService: LoginService,
    private config: PrimeNGConfig,
    private httpClient:HttpApiService,
              private translateService: TranslateService,
              @Inject(LOCALE_ID) private locale: string,) {

    this.translateService.addLangs(['en', 'es']);
    this.translateService.setDefaultLang('en');

    //Vamos a forzar el locale a es
    this.translate('es');

    this.initializeApp();
    }
      initializeApp() {

      //El this.router.navigate([''], {replaceUrl: true, relativeTo: this.route});
      this.httpClient.forbiddenRedirectUrl = '/login';

    };


    ngOnDestroy(): void {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }

    translate(lang: string) {
      console.log("LANGUAGE:" + lang)
      this.translateService.use(lang);
      this.subscription = this.translateService.get('primeng').subscribe((res: Translation) => {
        console.log("TRANSLATION SET")
        this.config.setTranslation(res);
        }
      );
    }
}
